import { useQuery } from 'react-query';

import { billingErrorToast } from '@components/BillingError/toast';
import { PaymentInfoProps, fetchPaymentInfo } from '@utils/backend-api/updatePayment';
import { BillingErrorPayload, normalizeBillingError } from '@utils/billingErrors';

const UPDATE_PAYMENT_KEY = 'UPDATE_PAYMENT_KEY';

const usePaymentInfo = () => {
  const { data, isLoading } = useQuery<PaymentInfoProps>(
    UPDATE_PAYMENT_KEY,
    () => fetchPaymentInfo(),
    {
      onError: (
        error: Partial<BillingErrorPayload> & { message?: string; redirect_to?: string }
      ) => {
        billingErrorToast(normalizeBillingError(error));
        if (error.redirect_to) {
          window.location.href = error.redirect_to;
        }
      },
    }
  );
  return { data, isLoading };
};

export default usePaymentInfo;
